import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'bootstrap/js/dist/popover'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/collapse'
import 'owl.carousel'
import '../sass/style.scss'
console.info('[wp-webpack-theme is live]')
